<template>
  <smd-one-col-layout content-styles="full-width">
    <div class="accepted">
      <pulsate-icon pulsateColor="green"
                    size="large">
        <img :src="$options.Ico017" alt="">
      </pulsate-icon>
      <div class="accepted__text-container">
        <p class="Title1">Accepted</p>
        <p class="Body1">The doctor will call you shortly...</p>
      </div>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {
    mapActions,
    mapGetters,
  } from 'vuex';
  import PulsateIcon from '@/views/ondemand/components/pulsate-icon.vue';
  import Ico017 from '@/assets/icons/ico017.svg';
  import {
    HOME_ROUTE,
  } from '@/router/routes';
  import {CallService} from '@/services/calls';
  import {logger} from '@/utils/logger';
  import {getAccessToken} from '@/utils/access-token';
  import {extractDateStringOnIsoString} from '@/utils';
  import {
    GETTER_ONDEMAND_BOOKING_DETAILS,
    GETTER_DOCTOR_PATIENT_PARTNER_BY_TOKEN,
    ACTION_EDIT_ACCOUNT,
  } from '@/store/types';
  import {getAccountWithDetailsService} from '@/services/account';

  export default {
    name: 'accepted',
    data() {
      return {
        fetchCount: 0,
        fetchIntervalReference: null,
        maxFetchCount: 10,
      }
    },
    components: {
      PulsateIcon,
    },
    computed: {
      ...mapGetters({
        onDemandDetails: GETTER_ONDEMAND_BOOKING_DETAILS,
        getterDoctorPatientByToken: GETTER_DOCTOR_PATIENT_PARTNER_BY_TOKEN,
      }),
    },
    mounted() {
      this.fetchActiveCall(); //run first fetch
      this.startFetchInterval();
    },
    destroyed() {
      clearInterval(this.fetchIntervalReference);
    },
    methods: {
      ...mapActions({
        editAccount: ACTION_EDIT_ACCOUNT,
      }),
      startFetchInterval() {
        this.fetchIntervalReference = setInterval(() => {
          if (this.fetchCount >= this.maxFetchCount) {
            this.$router.push({name: HOME_ROUTE});
            return;
          }

          this.fetchActiveCall();
        }, 10000);
      },
      async fetchActiveCall() {
        this.fetchCount = this.fetchCount + 1;

        let sessionsResponse;

        try {
          sessionsResponse = await CallService.getSessionsActive(getAccessToken());
        } catch (error) {
          // Skip this tick; interval will retry until maxFetchCount.
          logger.error('CallService.getSessionsActive XHR failed', {}, error);
          return;
        }

        const session = sessionsResponse.data[0];

        if (!session || !this.onDemandDetails) {
          return;
        }

        const accountData = await getAccountWithDetailsService();
        this.editAccount({
          firstname: accountData.firstname,
          middlename: accountData.middlename,
          lastname: accountData.lastname,
          birthdate: extractDateStringOnIsoString(accountData.birthdate),
          mobilenumber: accountData.mobilenumber,
          email: accountData.email,
          tokens: accountData.tokens,
        });

        let source = `${window.location.origin}/portal/`;
        const matchedPartner = this.getterDoctorPatientByToken[this.onDemandDetails.patienttoken];

        if (matchedPartner) {
          source = `${source}messages/${matchedPartner.doctor.usertag}/${matchedPartner.patient.id}`;
        }

        const callUrl = `${process.env.VUE_APP_SOCKET}/groupcalls/calls/?accesstoken=${session.accesstoken}&source=${source}`;
        window.location.href = callUrl;
      },
    },
    Ico017,
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .accepted {
    @extend %layout--flex-center-xy;
    height: 100%;
    gap: 16px;

    &__text-container {
      @extend %layout--flex-col;
      gap: 10px;
      text-align: center;
      max-width: 380px;

      @include responsive(mobile) {
        max-width: 280px;
      }

      .Title1 {
        color: #0FB16D;
      }
    }
  }
</style>
